import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import './People.css';

class People extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {

        const peopleSettings = {
            arrows: false,
            className: 'center',
            infinite: true,
            focusOnSelect: true,
            centerMode: true,
            variableWidth: true,
            speed: 400,
        };

        const navSettings = {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            className: 'centerNav',
            focusOnSelect: true,
            fade: true,
            speed: 400,
        };

        const { people } = this.props;

        if (!people) return null;

        const imageUrl = process.env.RAZZLE_ASSET_URL;

        return (
            <section className="section people-section">
                <div className="container content">
                    <div className="top-slider">
                        <Slider asNavFor={this.state.nav1} ref={slider => (this.slider2 = slider)} {...peopleSettings}>
                            {people.slice().map((panel, i) => {
                                return (
                                    <div key={panel._id}>
                                        <div className="headshots-bg">
                                            <div className="trilateral upwards"></div>
                                            <img src={imageUrl+`${panel.headshot}`} alt={imageUrl+`${panel.headshot}`} width="191" height="279"/>
                                            <div className="layer-mask"></div>
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                    <div className="bottom-slider">
                        <Slider asNavFor={this.state.nav2} ref={slider => (this.slider1 = slider)} {...navSettings}>
                            {people.slice().map((panel, i) => {
                                return (
                                    <div key={panel._id}>
                                        <div className="side">
                                            <div className="content-holder">
                                                <div className="content-bio">
                                                    <div className="slider-name">{panel.name}</div>
                                                    <div className="slider-title">{panel.title}</div>
                                                    <div className="slider-location">{panel.location}</div>
                                                </div>
                                                <div className="content-body">
                                                    <div className="slider-quotation">&ldquo;</div>
                                                    <div className="slider-quote">{panel.quote}</div>
                                                    <div className="slider-quotation">&rdquo;</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                </div >
            </section>
        );
    }
}

People.propTypes = {
    people: PropTypes.array,
};

export default People;
